import {
  Box,
  FormControl,
  FormHelperText,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";

const InputSelect = (props) => {
  if (props?.options && props.value !== undefined)
    return (
      <Box
        style={{
          height: props?.withLabel ? "56px" : "90px",
          marginTop: "10px",
          textAlign: "left",
        }}
      >
        <FormControl fullWidth>
          <TextField
            select
            disabled={props.disabled}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            sx={{
              "& .MuiInputBase-root.MuiOutlinedInput-root": {
                backgroundColor: !props?.withLabel && "#F6F8FC",
              },
            }}
            error={props.error}
            value={props?.value}
            onChange={props.onChange}
            InputProps={{
              startAdornment: props?.withLabel ? (
                <InputAdornment
                  sx={{
                    "&.MuiInputAdornment-root": {
                      minWidth: "180px",
                    },
                  }}
                  position="start"
                >
                  {props.label}
                </InputAdornment>
              ) : (
                props.startAdornment
              ),
            }}
          >
            {props?.options?.map((item) => (
              <MenuItem key={item.key} label={item.value} value={item.key}>
                {item?.value}
              </MenuItem>
            ))}
          </TextField>
          <FormHelperText error={props.error}>
            {props?.helperText}
          </FormHelperText>
        </FormControl>
      </Box>
    );
};

export default InputSelect;
